import { IKlokReservationTableData } from '~/zustand/gfp/gfp-service-state';
import CreateGfpItems from '../../model/gfp/CreateGfpItems';
import Stock from '../../model/stock/Stocks';

export class MapStockSelectedToGfpItems {
  static toGfpItems(stocks: Stock[], campaignId?: number): CreateGfpItems[] {
    const items: CreateGfpItems[] = [];

    for (let i = 0; i < stocks.length; i++) {
      const stock = stocks[i];
      const obs1Value = stock.observationId1 ? Number(stock.observationId1) : undefined;
      const obs2Value = stock.observationId2 ? Number(stock.observationId2) : undefined;
      items.push({
        stockId: stock.stockId,
        packingId: stock.packingId as number,
        quantityPacking: Number(stock.quantityPacking),
        unitQuantity: Number(stock.quantityPerPacking),
        obs1: obs1Value && !isNaN(obs1Value) ? obs1Value : undefined,
        obs2: obs2Value && !isNaN(obs2Value) ? obs2Value : undefined,
        observation: stock.observation,
        campaignId,
      });
    }
    return items;
  }

  static toGfpItemsFromKlokReservations(
    klokReservations: IKlokReservationTableData[],
    campaignId?: number,
  ): CreateGfpItems[] {
    const items: CreateGfpItems[] = [];

    for (let i = 0; i < klokReservations.length; i++) {
      const reservation = klokReservations[i];
      items.push({
        klokReservationId: reservation.id,
        packingId: reservation.packingId,
        quantityPacking: Number(reservation.packingQuantity),
        unitQuantity: Number(reservation.unitQuantity),
        obs1: reservation.qualityObservationId1 || undefined,
        obs2: reservation.qualityObservationId2 || undefined,
        observation: reservation.observation,
        campaignId,
      });
    }
    return items;
  }
}
